import React from 'react';

export default () => {
  return (
    <div>
      <h1>More Blogs Coming!!!!</h1>
    </div>
  );
};
